import React, { useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FiArrowLeft, FiCheck, FiLock, FiPhone } from "react-icons/fi";
import styles from "./ForgotChange.module.css";
import api from "../../services/axiosConfig";
import { FORGOTPASS } from "../../constant-value";
import { validationChangePass2Schema } from "../../constant-value/schema";

const ForgotChange = () => {
  const { mobile } = useParams();
  const navigate = useNavigate();

  const [body, setBody] = useState({
    phoneNumber: mobile,
    newPassword: null,
    confirmPassword: null,
    otpCode: null,
  });

  const message = (text, type) => {
    if (type === "warn") {
      toast.warning(text, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.success(text, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleSubmit,
  } = useFormik({
    enableReinitialize: true,
    initialValues: body,
    validationSchema: validationChangePass2Schema,

    onSubmit: () => {
      api
        .post(`/${FORGOTPASS}`, body)
        .then((res) => {
          if (res.data.isSuccess) {
            message(res.data.message, "success");
            navigate("/login");
          } else {
            message(res.data.message, "warn");
          }
        })
        .catch((error) => {
          const serverMessage = error.response?.data?.message;

          message(
            serverMessage || "چند دقیقه دیگر تلاش نمایید، خطایی رخ داده است",
            "warn"
          );
        });
    },
  });

  const changeHandle = (evt) => {
    const { id, value } = evt.target;

    setBody((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return (
    <div className={styles.page} dir="rtl">
      <div className={styles.card}>
        {/* Icon */}
        <div className={styles.iconBox}>
          <FiLock />
        </div>

        <div className={styles.step}>مرحله نهایی</div>

        <h1 className={styles.title}>تغییر رمز عبور</h1>

        <p className={styles.description}>
          رمز عبور جدید خود را وارد کنید تا حساب کاربری شما به‌روزرسانی شود.
        </p>

        {/* Mobile */}
        <div className={styles.field}>
          <label htmlFor="mobile">شماره همراه</label>

          <div className={styles.inputWrapper}>
            <FiPhone className={styles.inputIcon} />

            <input
              id="mobile"
              type="text"
              value={mobile}
              disabled
              className={styles.input}
            />
          </div>

          <span className={styles.helper}>
            این شماره قابل ویرایش نیست
          </span>
        </div>

        {/* New Password */}
        <div className={styles.field}>
          <label htmlFor="newPassword">رمز عبور جدید</label>

          <div
            className={`${styles.inputWrapper} ${
              errors.newPassword && touched.newPassword
                ? styles.invalid
                : ""
            }`}
          >
            <FiLock className={styles.inputIcon} />

            <input
              id="newPassword"
              type="password"
              value={values.newPassword || ""}
              onChange={changeHandle}
              onBlur={handleBlur}
              placeholder="رمز عبور جدید"
              className={styles.input}
              autoComplete="new-password"
            />
          </div>

          {errors.newPassword && touched.newPassword && (
            <div className={styles.error}>
              {errors.newPassword}
            </div>
          )}
        </div>

        {/* Confirm Password */}
        <div className={styles.field}>
          <label htmlFor="confirmPassword">تکرار رمز عبور</label>

          <div
            className={`${styles.inputWrapper} ${
              errors.confirmPassword && touched.confirmPassword
                ? styles.invalid
                : ""
            }`}
          >
            <FiLock className={styles.inputIcon} />

            <input
              id="confirmPassword"
              type="password"
              value={values.confirmPassword || ""}
              onChange={changeHandle}
              onBlur={handleBlur}
              placeholder="تکرار رمز عبور"
              className={styles.input}
              autoComplete="new-password"
            />
          </div>

          {errors.confirmPassword && touched.confirmPassword && (
            <div className={styles.error}>
              {errors.confirmPassword}
            </div>
          )}
        </div>

        {/* Submit */}
        <button
          type="button"
          onClick={handleSubmit}
          disabled={isSubmitting}
          className={styles.submitButton}
        >
          {isSubmitting ? (
            <>
              <span className={styles.spinner} />
              در حال ثبت...
            </>
          ) : (
            <>
              <FiCheck />
              ثبت تغییرات
            </>
          )}
        </button>

        {/* Back */}
        <button
          type="button"
          className={styles.backButton}
          onClick={() => navigate("/login")}
        >
          <FiArrowLeft />
          بازگشت به ورود
        </button>

        <div className={styles.footer}>
          پس از تغییر موفق رمز عبور، به صفحه ورود منتقل خواهید شد.
        </div>
      </div>
    </div>
  );
};

export default ForgotChange;